export const swapSkillSynonymToSkillType = ({ skill, ...skillSynonym }) => ({
  ...skill,
  __typename: 'Skill',
  synonym: skillSynonym,
});
